// AddCategory.js
import React, { useState } from "react";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../../firebase";
import {
  TextField,
  Button,
  Grid,
  Container,
  Typography,
  Card,
  CardContent,
  Snackbar,
  Alert,
} from "@mui/material";
import { v4 as uuidv4 } from "uuid";

const AddCategory = () => {
  const [category, setCategory] = useState({
    description: "",
    id: "",
    router_to: "",
    title: "",
  });

  const [openSnackbar, setOpenSnackbar] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCategory((prevCategory) => ({
      ...prevCategory,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const uniqueId = uuidv4();
    const categoryData = {
      ...category,
      id: uniqueId,
      router_to: category.router_to.toLowerCase(),
      timestamp: serverTimestamp(),
    };

    try {
      await setDoc(doc(db, "topic", uniqueId), categoryData);
      setOpenSnackbar(true);
      setCategory({
        description: "",
        id: "",
        imageUrl: "",
        router_to: "",
        title: "",
      });
    } catch (error) {
      console.error("Error adding category: ", error);
      alert("Error adding category");
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  return (
    <Container
      maxWidth="sm"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <Card>
        <CardContent>
          <Typography variant="h4" component="h1" gutterBottom>
            Add New Topic
          </Typography>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Title"
                  name="title"
                  value={category.title}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Description"
                  name="description"
                  value={category.description}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="ID"
                  name="id"
                  value={category.id}
                  onChange={handleChange}
                  required
                  disabled
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Router"
                  name="router_to"
                  value={category.router_to}
                  onChange={handleChange}
                  required
                  inputProps={{ style: { textTransform: "lowercase" } }}
                />
              </Grid>

              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  fullWidth
                >
                  Add Category
                </Button>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </Card>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="success"
          sx={{ width: "100%" }}
        >
          Category added successfully!
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default AddCategory;
